import styled from 'styled-components';

export const LightBox = styled.div`
  /** Based on http://codepen.io/gschier/pen/HCoqh */

  /** Position and style */
  position: fixed;
  z-index: 999999;
  width: 100%;
  height: 100%;
  text-align: center;
  top: 0;
  left: 0;
  box-sizing: border-box;
  background: rgba(0, 0, 0, 0.8);

  /** Remove default browser outline */
  outline: none;
`;
